import React, { useRef } from 'react'
import { NumericTextBox } from '@progress/kendo-react-inputs';
import { FieldWrapper } from '@progress/kendo-react-form';
import { Error, Hint } from '@progress/kendo-react-labels';
import LabelPure from '../../../pures/label/label.pure';

function NumericTextboxWrapper(fieldRenderProps) {
    const {
        touched,
        label,
        id,
        valid,
        hint,
        validationMessage,
        ...others
    } = fieldRenderProps;

    const editorRef = useRef(null);
    const showValidationMessage = touched && validationMessage;
    const showHint = !showValidationMessage && hint;
    const hintId = showHint ? `${id}_hint` : "";
    const errorId = showValidationMessage ? `${id}_error` : "";
    const labelId = label ? `${id}_label` : "";

    return (
        <FieldWrapper className={`numericTextboxWrapper ${showValidationMessage ? "numericTextboxWrapper-error" : ""}`}>
            <LabelPure
                id={labelId}
                editorId={id}
                className="k-form-label"
                title={label}
            />
            <div className={"k-form-field-wrap"}>
                <NumericTextBox
                    ariaLabelledBy={labelId}
                    ariaDescribedBy={`${hintId} ${errorId}`}
                    ref={editorRef}
                    id={id}
                    fillMode="flat"
                    rounded={false}
                    spinners={false}
                    validationMessage={validationMessage}
                    {...others}
                    valid={!showValidationMessage}
                />
                {showHint && <Hint id={hintId}>{hint}</Hint>}
                {showValidationMessage && (
                    <Error id={errorId}>{validationMessage}</Error>
                )}
            </div>
        </FieldWrapper>
    )
};

export default NumericTextboxWrapper